import cn from 'classnames';
import { PromoFooterContainer } from 'containers/common/PromoFooterContainer';
import React from 'react';

import AbstractBackground from 'components/basic/AbstractBackground';
import { AuthModal } from 'components/complex/modals/AuthModal';
import { RegistrationModal } from 'components/complex/modals/RegistrationModal';
import { NotificationContainer } from 'components/domains/common/Notifications/container';
import Footer from 'components/layouts/Footer';
import FullFooter from 'components/layouts/FullFooter';
import Header from 'components/layouts/Header';
import { MobileMenuModal } from 'components/layouts/Header/MobileMenuModal';
import { HtmlHead } from 'components/layouts/HtmlHead';

import { useAppSelector } from 'redux-store';

import s from './Page.module.scss';

interface Props {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ //тут всё не перечислишь
  children: any;
  fullHeight?: boolean;
  fullWidth?: boolean;
  withoutHeader?: boolean;
  withoutFooter?: boolean;
  withoutAbstractBackground?: boolean;
  fullFooter?: boolean;
  className?: string;
  grid?: boolean;
  removeBottomPadding?: boolean;
  seo?: {
    title?: string;
    description?: string;
    canonical?: string;
  };
  tags?: JSX.Element[],
  headerClassName?: string;
  hideLinkInHeader?: boolean;
  withoutLogo?: boolean;
  availableCookie?: boolean;
}

export default function Page({
  children,
  withoutHeader,
  withoutFooter,
  withoutAbstractBackground = false,
  fullFooter,
  removeBottomPadding,
  headerClassName,
  grid,
  fullHeight,
  fullWidth,
  className,
  seo,
  tags,
  hideLinkInHeader,
  withoutLogo,
  availableCookie = true,
  
}: Props): JSX.Element {
  const profileStore = useAppSelector(state => state.profile);

  return (
    <>
      <PromoFooterContainer availableCookie={availableCookie} />
      <HtmlHead {...seo} tags={tags} />
      <div className={s.root}>
        {!withoutAbstractBackground &&
          <AbstractBackground />
        }
        {!withoutHeader && (
          <Header
            className={cn(s.headerContainer, headerClassName)}
            hideLink={hideLinkInHeader}
            withoutLogo={withoutLogo}
          />
        )}
        <main
          className={cn(s.contentContainer, className, {
            grid,
            [s.fullHeight]: fullHeight,
            [s.fullWidth]: fullWidth,
            [s.removeBlockEndPadding]: removeBottomPadding,
          })}
        >
          {children}
        </main>

        {!withoutFooter ? (
          fullFooter ? (
            <FullFooter className={s.footerContainer} />
          ) : (
            <Footer className={s.footerContainer} />
          )
        ) : (
          ''
        )}
      </div>
      <MobileMenuModal />
      {!profileStore.isAuthenticated && (
        <>
          <AuthModal />
          <RegistrationModal />
        </>
      )}
      <NotificationContainer />
    </>
  );
}
